module.exports = "<div [id]=\"modalId\" class=\"modal\" tabindex=\"-1\" data-backdrop=\"false\">\n  <div class=\"modal-dialog modal-dialog-centered\">\n    <div class=\"modal-content\">\n      <div *ngIf=\"title\" class=\"modal-header\">\n        <h3 class=\"modal-title center\">{{ title }}</h3>\n      </div>\n      <div class=\"modal-body\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/simple-modal/simple-modal.component.html
// module id = ../../../../../src/app/core/simple-modal/simple-modal.component.html
// module chunks = main